export default "__VITE_ASSET__DsSbmjmg__"